import type { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from '@reduxjs/toolkit';

import type { ITeacherCategoryList, ITeacherCategoryListCategory } from '@/Module/Teacher/Model/DataModel';
import { getTeacherListByCategoryIdAction } from '@/Module/Teacher/Store/Action/getTeacherListByCategoryIdAction';
import { teacherCategoryAdapter } from '@/Module/Teacher/Store/Adapter';
import { categoryTeacherListAdapter } from '@/Module/Teacher/Store/Adapter/categoryTeacherListAdapter';

const prepareDefaultCategory = (category: ITeacherCategoryListCategory): ITeacherCategoryList => ({
  category,
  teacherList: teacherCategoryAdapter.getInitialState({
    isLoading: false,
  }),
  page: 0,
  total: 0,
  pageRows: 3,
  isLoading: false,
});

const initialState = categoryTeacherListAdapter.setAll(
  categoryTeacherListAdapter.getInitialState({
    isLoading: false,
  }),
  [
    prepareDefaultCategory({
      color: 'orange',
      title: 'متوسطه اول',
      id: 2,
    }),
    prepareDefaultCategory({
      color: 'pink',
      title: 'علوم انسانی',
      id: 19,
    }),
    prepareDefaultCategory({
      color: 'primary',
      title: 'ریاضی فیزیک',
      id: 18,
    }),
    prepareDefaultCategory({
      color: 'orange',
      title: 'علوم تجربی',
      id: 20,
    }),
  ],
);

const TeacherCategorySlice = createSlice({
  name: 'teacherCategory',
  initialState,
  reducers: {
    nextPage: (state, { payload }: PayloadAction<ITeacherCategoryListCategory['id']>) => {
      categoryTeacherListAdapter.updateOne(state, {
        id: payload,
        changes: {
          page: state.entities[payload]!.page + 1,
        },
      });
    },
    setPage: (state, { payload: [categoryId, page] }: PayloadAction<[ITeacherCategoryListCategory['id'], number]>) => {
      categoryTeacherListAdapter.updateOne(state, {
        id: categoryId,
        changes: {
          page,
        },
      });
    },
  },
  extraReducers: builder => {
    builder
      .addCase(getTeacherListByCategoryIdAction.pending, state => {
        state.isLoading = true;
      })
      .addCase(getTeacherListByCategoryIdAction.rejected, state => {
        state.isLoading = true;
      })
      .addCase(getTeacherListByCategoryIdAction.fulfilled, (state, { payload, meta }) => {
        state.isLoading = false;
        const category = state.entities[meta.arg]!;
        category.total = payload.total;

        if (category.page === 0) {
          teacherCategoryAdapter.setAll(category.teacherList, payload.data.teachersInfo);
        } else {
          teacherCategoryAdapter.addMany(category.teacherList, payload.data.teachersInfo);
        }
      });
  },
});

export const { nextPage: teacherCategoryNextPageAction } = TeacherCategorySlice.actions;

export default TeacherCategorySlice;
